// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Cxvb3","title":"FrontImage_title__3_N-D"};